import services from './_services'

export default {
  getTags () {
    return services.get(process.env.ROOT_API + '/administration/wordpress-tags/')
  },
  updateTag (tagID, tagData) {
    return services.post(process.env.ROOT_API + '/administration/wordpress-tags/' + tagID + '/', tagData
    )
  }
}



// WEBPACK FOOTER //
// ./src/api/wordpressTags.js